<template>
  <div id="notifications">
    <h1>WhatsApp</h1>
    <v-app id="inspire">
      <v-card>
        <v-card-title>
          Notifications
         <v-col class="d-flex" cols="7" sm="4">
        <v-select v-model="selected"
          :items="notificationValues"
          label="Select messenger"
           @change='myD'
          outlined
        ></v-select>
      </v-col>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="myitems" :search="search" sort-field="durations"></v-data-table>
      </v-card>
    </v-app>
  </div>
</template>
<style scoped>
</style>
<script>
import { notification } from "../../firebaseConfig";
export default {
  name: "Notifications",
  data() {
    return {
       notificationValues: ['WhatsApp', 'Instagram'],
      search: "",
      selected:null,
      myitems: [],
       lists: {},
      headers: [
        {
          text: "Packages",
          align: "start",
          sortable: false,
          value: "packages"
        },
        { text: "Title", value: "title" },
        { text: "Text", value: "text" },
        { text: "Time", value: "time" }
      ],
      desserts: [
        {
          deviceID: "Frozen Yogurt",
          durations: 159,
          name: 6.0,
          carbs: 24,
          number: 4.0,
          time: "1%"
        }
      ]
    };
  },
  mounted: function() {
    this.tabeRe();
  },
  methods: {
    async myD() {

      if(this.selected==null || this.selected=='WhatsApp' ){
      return notification
        .child("78KOHWXhC0UTR3fxqkqsoJ7j1Ew1")
        .child("868068040704056")
        .orderByChild('packages')
        .equalTo('com.whatsapp')
        .on("value", snapshot => {
          // console.log(snapshot.val());
          //  this.lists=snapshot.val();
          //  console.log(this.lists);
     this.myitems =  Object.values(snapshot.val())
         });
      }else if(this.selected=='Instagram')
      {
          return notification
        .child("78KOHWXhC0UTR3fxqkqsoJ7j1Ew1")
        .child("868068040704056")
        .orderByChild('packages')
        .equalTo('com.instagram.android')
        .on("value", snapshot => {
          // console.log(snapshot.val());
          //  this.lists=snapshot.val();
          //  console.log(this.lists);
     this.myitems =  Object.values(snapshot.val())
         });

      }
      
    },
   tabeRe() {
     this.myD();
    },
    RefreshGrid()
    { 

      console.log(this.selected)
    }
  }
};
</script>